export default __webpack_public_path__ + "static/media/assistant_tip2.dcd0f975.png";